import FieldsPage from './list';

export default FieldsPage;
